import { Ref, ref } from "vue";
import { KeyValueStorage } from "../storage/types";
import { isJwtTokenExpired } from "./utils";

export const useOnceJwtAuthToken = (storage: Ref<KeyValueStorage>, storageCode = "api_token") => {

    const isAuthenticated = ref(false);

    const loadJwt = () => {
        return storage.value?.get(storageCode);
    };

    const checkAuthenticated = async () => {
        const token = await loadJwt();

        if (token && isJwtTokenExpired(token)) {
            await deleteJwt(); //TODO: can this create a recursive endless loop?
        }
        const value = !!(await loadJwt()); //check again after possible deletion
        isAuthenticated.value = value;
        return value;
    };


    const deleteJwt = async () => {
        storage.value.remove(storageCode);
        await checkAuthenticated();
    };


    const saveJwt = async (jwt: string) => {
        await storage.value.set(storageCode, jwt);
        await checkAuthenticated();
    };

    return {
        isAuthenticated,
        checkAuthenticated,
        loadJwt,
        deleteJwt,
        saveJwt
    };
};